import ProductTempleteAmpturn from "../templates/product-templete-large";
import { LTMoulded } from '../data/products'

function ProductAmpturnMoulded() {
    return (
        <>
            <ProductTempleteAmpturn data = {LTMoulded}/>
        </>
    )
}

export default ProductAmpturnMoulded;